export var PaymentType;
(function (PaymentType) {
    PaymentType["online"] = "online";
    PaymentType["offline"] = "offline";
})(PaymentType || (PaymentType = {}));
export var DeliveryType;
(function (DeliveryType) {
    DeliveryType["table"] = "table";
    DeliveryType["delivery"] = "delivery";
    DeliveryType["takeaway"] = "takeaway";
})(DeliveryType || (DeliveryType = {}));
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["new"] = "new";
    OrderStatus["wip"] = "wip";
    OrderStatus["ready"] = "ready";
    OrderStatus["done"] = "done";
})(OrderStatus || (OrderStatus = {}));
